import { AWS_API_URL } from 'global/environment';
import { authorize, deleteRequest } from 'utils/http';

const backendURL = `${AWS_API_URL}/lighting/groups`;

export async function deleteLightningGroupAPI(groupId) {
  return deleteRequest(`${backendURL}/${groupId}`, await authorize());
}
